export default __webpack_public_path__ + "static/media/Uieye.1c2f69ad.svg";